import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {TimePeriod} from '../classes/TimePeriod';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class TimePeriodService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<TimePeriod[]> {
    return this.httpClient.get<TimePeriod[]>(`${environment.backendApiUrl}/v1/timeperiods`, httpOptions);
  }

  public addOrEdit(timePeriod: TimePeriod): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/timeperiods`, timePeriod, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/timeperiods/` + id, httpOptions);
  }
}
